(function () {
    'use strict';

    function entityPublishingModalController($scope, $uibModalInstance, mailRequestDataService, notifyService,
        publishingState, entityId) {
        $scope.publishingState = publishingState;
        $scope.ok = function () {
            $uibModalInstance.close();
        };

        $scope.sendPremiumUpgradeRequest = function () {
            mailRequestDataService.sendPremiumUpgradeRequest({
                EntityId: entityId
            }).then(function(data) {
                notifyService.notify('Your request to upgrade to a Premium account has been sent');
            });
        }
    }

    entityPublishingModalController.$inject = ['$scope', '$uibModalInstance', 'mailRequestDataService', 'notifyService',
        'publishingState', 'entityId'];

    angular.module('ecap.dashboards').controller('entityPublishingModalController', entityPublishingModalController);
})();
